/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetBracketsMatchesMatchidReplayNarrativeQueryResponse,
  GetBracketsMatchesMatchidReplayNarrativePathParams,
} from "../types/GetBracketsMatchesMatchidReplayNarrative.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getBracketsMatchesMatchidReplayNarrativeQueryKey = (
  matchId:
    GetBracketsMatchesMatchidReplayNarrativePathParams["matchId"] | undefined,
) =>
  [
    {
      url: "/brackets/matches/:matchId/replay-narrative",
      params: { matchId: matchId },
    },
  ] as const;

export type GetBracketsMatchesMatchidReplayNarrativeQueryKey = ReturnType<
  typeof getBracketsMatchesMatchidReplayNarrativeQueryKey
>;

/**
 * @summary KAN-729: разбор матча — что именно сделало результат. Список по игре на каждую
 * игру серии. Пустой список — реплеев нет либо сторон в данных меньше двух.
 * Готового текста здесь нет: приходит структура утверждений, фразы собирает витрина
 * через i18n. Иначе русский текст жил бы в бэкенде, а английская версия сайта
 * получала бы русские предложения.
 * {@link /brackets/matches/:matchId/replay-narrative}
 */
export async function getBracketsMatchesMatchidReplayNarrative(
  matchId: GetBracketsMatchesMatchidReplayNarrativePathParams["matchId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetBracketsMatchesMatchidReplayNarrativeQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: "GET",
    url: `/brackets/matches/${matchId}/replay-narrative`,
    ...requestConfig,
  });
  return res;
}

export function getBracketsMatchesMatchidReplayNarrativeQueryOptions(
  matchId:
    GetBracketsMatchesMatchidReplayNarrativePathParams["matchId"] | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getBracketsMatchesMatchidReplayNarrativeQueryKey(matchId);
  return queryOptions<
    ResponseConfig<GetBracketsMatchesMatchidReplayNarrativeQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<GetBracketsMatchesMatchidReplayNarrativeQueryResponse>,
    typeof queryKey
  >({
    enabled: !!matchId,
    queryKey,
    queryFn: async ({ signal }) => {
      return getBracketsMatchesMatchidReplayNarrative(matchId!, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @summary KAN-729: разбор матча — что именно сделало результат. Список по игре на каждую
 * игру серии. Пустой список — реплеев нет либо сторон в данных меньше двух.
 * Готового текста здесь нет: приходит структура утверждений, фразы собирает витрина
 * через i18n. Иначе русский текст жил бы в бэкенде, а английская версия сайта
 * получала бы русские предложения.
 * {@link /brackets/matches/:matchId/replay-narrative}
 */
export function useGetBracketsMatchesMatchidReplayNarrative<
  TData = ResponseConfig<GetBracketsMatchesMatchidReplayNarrativeQueryResponse>,
  TQueryData =
    ResponseConfig<GetBracketsMatchesMatchidReplayNarrativeQueryResponse>,
  TQueryKey extends QueryKey = GetBracketsMatchesMatchidReplayNarrativeQueryKey,
>(
  matchId:
    GetBracketsMatchesMatchidReplayNarrativePathParams["matchId"] | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetBracketsMatchesMatchidReplayNarrativeQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ??
    getBracketsMatchesMatchidReplayNarrativeQueryKey(matchId);

  const query = useQuery(
    {
      ...getBracketsMatchesMatchidReplayNarrativeQueryOptions(matchId, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
